import { useState } from "react"

import "./NotificationModal.scss"
import Backdrop from "../Backdrop/Backdrop"
import { Cycle } from "~/types"

type NotificationModalProps = {
  cycle: Cycle
}

export default function NotificationModal({ cycle }: NotificationModalProps) {
  const [permission, setPermission] = useState(window.Notification?.permission)

  if (permission !== "default" || process.env.RAILS_ENV === "test") return null

  const handleClick = () => {
    Notification.requestPermission().then(setPermission)
  }

  return (
    <Backdrop>
      <div className={`NotificationModal NotificationModal--${cycle}`}>
        <h1 className="NotificationModal__title">
          Enable <strong>notifications</strong>?
        </h1>

        <div className="NotificationModal__description">
          <p>We'll let you know when:</p>
          <ul>
            <li>Your timer ends</li>
            <li>Someone joins/leaves your space</li>
          </ul>
        </div>

        <button className="NotificationModal__button" onClick={handleClick}>
          Make my choice
        </button>

        <div className="NotificationModal__disclaimer">
          <p>We{"'"}ll only bother you this once.</p>

          <p>
            Should you change your mind, you can always change the permissions
            for the site through your browser{"'"}s settings.
          </p>
        </div>
      </div>
    </Backdrop>
  )
}
